import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@deckspace/client';
import type { ApiClient } from '@deckspace/client';
import { fetchWorkspaceDetail, type WorkspaceDetail } from '../lib/queries';
import { queryKeys } from '../lib/queryKeys';

/**
 * Hook to fetch a single workspace's detail via API client.
 */
export function useWorkspace(api: ApiClient, workspaceId: string | undefined) {
  const { user } = useAuth();

  const {
    data: workspace = null,
    isPending,
    error,
  } = useQuery<WorkspaceDetail | null>({
    queryKey: queryKeys.workspace.detail(workspaceId!),
    queryFn: async () => {
      const result = await fetchWorkspaceDetail(api, workspaceId!);
      if (!result) throw new Error('Workspace not found');
      return result;
    },
    enabled: !!workspaceId && !!user,
    structuralSharing: false,
  });

  return { workspace, isPending, error: error as Error | null };
}
